import * as fromDatatype from '../datatype-library/index';

export interface bl_mrp_job_order_generic_doc_link_RowInterface {
  guid: fromDatatype.GuidDataFieldInterface;
  job_order_guid: fromDatatype.GuidDataFieldInterface;
  job_order_date: fromDatatype.TimestampTzDatatypeInterface;
  generic_doc_hdr_guid: fromDatatype.GuidDataFieldInterface;
  generic_doc_line_guid: fromDatatype.GuidDataFieldInterface;
  generic_doc_hdr_date: fromDatatype.TimestampTzDatatypeInterface;
  txn_type: fromDatatype.VarcharDatatypeInterface;
  logic: fromDatatype.VarcharDatatypeInterface;
  option: fromDatatype.VarcharDatatypeInterface;
  descr: fromDatatype.VarcharDatatypeInterface;
  remarks : fromDatatype.VarcharDatatypeInterface;
  quantity_contra: fromDatatype.NumericDatatypeInterface;
  quantity_signum: fromDatatype.NumericDatatypeInterface;          
  amount_contra: fromDatatype.NumericDatatypeInterface;
  amount_signum: fromDatatype.NumericDatatypeInterface;
  txn_date: fromDatatype.TimestampTzDatatypeInterface;
  log_json: any;
  job_order_no: fromDatatype.VarcharDatatypeInterface;
  category_guid: fromDatatype.GuidDataFieldInterface;
  category_group_guid: fromDatatype.GuidDataFieldInterface;
  qc_output_status: fromDatatype.VarcharDatatypeInterface;
  job_order_status: fromDatatype.VarcharDatatypeInterface;
  estimated_packing_date: null;
  completion_date: fromDatatype.TimestampTzDatatypeInterface;
  container_quantity: fromDatatype.NumericDatatypeInterface;
  ad_hoc_quantity: fromDatatype.NumericDatatypeInterface;
  total_container_measure: fromDatatype.NumericDatatypeInterface;
  server_doc_type_job_order: fromDatatype.VarcharDatatypeInterface;
  server_doc_type_generic_doc: fromDatatype.VarcharDatatypeInterface;
  client_doc_status_01: fromDatatype.VarcharDatatypeInterface;
  client_doc_status_02: fromDatatype.VarcharDatatypeInterface;
  client_doc_status_03: fromDatatype.VarcharDatatypeInterface;
  client_doc_status_04: fromDatatype.VarcharDatatypeInterface;
  client_doc_status_05: fromDatatype.VarcharDatatypeInterface;
  property_json: any;
  module_guid: fromDatatype.GuidDataFieldInterface;
  applet_guid: fromDatatype.GuidDataFieldInterface;
  created_date: fromDatatype.TimestampTzDatatypeInterface;
  updated_date: fromDatatype.TimestampTzDatatypeInterface;
  created_by_subject_guid: fromDatatype.GuidDataFieldInterface;
  updated_by_subject_guid: fromDatatype.GuidDataFieldInterface;
  status: fromDatatype.StatusDataFieldInterface;
  revision: fromDatatype.RevisionDataFieldInterface;
  vrsn: fromDatatype.VrsnDataFieldInterface;
  namespace: fromDatatype.VarcharDatatypeInterface;
  acl_config: fromDatatype.JsonDatatypeInterface;
  acl_policy: fromDatatype.JsonDatatypeInterface;    
  job_doc_state: fromDatatype.VarcharDatatypeInterface;
  scenario_option: fromDatatype.VarcharDatatypeInterface;
}

export class bl_mrp_job_order_generic_doc_link_RowClass
  implements bl_mrp_job_order_generic_doc_link_RowInterface {
    guid: fromDatatype.GuidDataFieldInterface;
    job_order_guid: fromDatatype.GuidDataFieldInterface;
    job_order_date: fromDatatype.TimestampTzDatatypeInterface;
    generic_doc_hdr_guid: fromDatatype.GuidDataFieldInterface;
    generic_doc_line_guid: fromDatatype.GuidDataFieldInterface;
    generic_doc_hdr_date: fromDatatype.TimestampTzDatatypeInterface;
    txn_type: fromDatatype.VarcharDatatypeInterface;
    logic: fromDatatype.VarcharDatatypeInterface;
    option: fromDatatype.VarcharDatatypeInterface;
    descr: fromDatatype.VarcharDatatypeInterface;
    remarks : fromDatatype.VarcharDatatypeInterface;
    quantity_contra: fromDatatype.NumericDatatypeInterface;
    quantity_signum: fromDatatype.NumericDatatypeInterface;          
    amount_contra: fromDatatype.NumericDatatypeInterface;
    amount_signum: fromDatatype.NumericDatatypeInterface;
    txn_date: fromDatatype.TimestampTzDatatypeInterface;
    log_json: any;
    job_order_no: fromDatatype.VarcharDatatypeInterface;
    category_guid: fromDatatype.GuidDataFieldInterface;
    category_group_guid: fromDatatype.GuidDataFieldInterface;
    qc_output_status: fromDatatype.VarcharDatatypeInterface;
    job_order_status: fromDatatype.VarcharDatatypeInterface;
    estimated_packing_date: null;
    completion_date: fromDatatype.TimestampTzDatatypeInterface;
    container_quantity: fromDatatype.NumericDatatypeInterface;
    ad_hoc_quantity: fromDatatype.NumericDatatypeInterface;
    total_container_measure: fromDatatype.NumericDatatypeInterface;
    server_doc_type_job_order: fromDatatype.VarcharDatatypeInterface;
    server_doc_type_generic_doc: fromDatatype.VarcharDatatypeInterface;
    client_doc_status_01: fromDatatype.VarcharDatatypeInterface;
    client_doc_status_02: fromDatatype.VarcharDatatypeInterface;
    client_doc_status_03: fromDatatype.VarcharDatatypeInterface;
    client_doc_status_04: fromDatatype.VarcharDatatypeInterface;
    client_doc_status_05: fromDatatype.VarcharDatatypeInterface;
    property_json: any;
    module_guid: fromDatatype.GuidDataFieldInterface;
    applet_guid: fromDatatype.GuidDataFieldInterface;
    created_date: fromDatatype.TimestampTzDatatypeInterface;
    updated_date: fromDatatype.TimestampTzDatatypeInterface;
    created_by_subject_guid: fromDatatype.GuidDataFieldInterface;
    updated_by_subject_guid: fromDatatype.GuidDataFieldInterface;
    status: fromDatatype.StatusDataFieldInterface;
    revision: fromDatatype.RevisionDataFieldInterface;
    vrsn: fromDatatype.VrsnDataFieldInterface;
    namespace: fromDatatype.VarcharDatatypeInterface;
    acl_config: fromDatatype.JsonDatatypeInterface;
    acl_policy: fromDatatype.JsonDatatypeInterface; 
    job_doc_state: fromDatatype.VarcharDatatypeInterface;
    scenario_option: fromDatatype.VarcharDatatypeInterface;
}
